import { IMedicinePrescription, IPatientRedFlag, IPatientSystemReview } from "@curefit/ehr-common";
import { Goal, UserGoalView } from "@curefit/gmf-common";
import * as _ from "lodash";
import * as React from "react";
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import ErrorContainer from "../../containers/ErrorContainer";
import IDoctorProfile from "../../models/IDoctorProfile";
import IEditedBy from "../../models/IEditedBy";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import IMedicineType from "../../models/staticData/IMedicineType";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppMessages, CheckinType, ConfigConstants, ConsultationStatusConstant, DosageSlots, TabNames } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import removeQ from "../../utils/DataUtils";
import { EditViewDisplayMode } from "../common/EditViewCard";
import { IDoctorCheckInInfo, IAppointmentScheduleResponse, ISymptom } from "@curefit/care-common";
import { ConsultationPrescriptionItemRequest } from "@curefit/gmf-common";
import ModelFactory from "../../models/ModelFactory";
import { MODAL_SCREENS } from "../../containers/Ongoing/OngoingConsultationContainer";
import {default as CTA, CTATheme} from "../common/CallToAction";
import {sessionNotesConfiguration} from "../../SectionConfigurations/sessionNotesConfiguration";

export interface PatientTherapistPlanTabProps {
    editedBy: IEditedBy,
    patientId: number,
    secondaryPatientId: number,
    bookingId: number,
    consultationId: number,
    consultationType: string,
    doctorType: string,
    staticSpecialities: any[],
    staticMedicineTypes: IMedicineType[],
    patientPlan: IPatientLifestylePlanWrapper,
    fetchStaticLabTestsData: (input: string) => Promise<any>,
    patientGoals: UserGoalView[],
    staticGoals: Goal[],
    fetchPlanStaticData: () => any,
    saveEditedPatientProfile: (updatedPatientPlan: IPatientLifestylePlanWrapper | IEHRSavePatientMedicalProfile) => void;
    reviewPlan: (flag: boolean, clearPdfData: boolean, modalScreen: string) => void;
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>;
    fetchStaticSymptomsData: (input: string) => Promise<any>;
    fetchStaticDiseaseData: (input: string) => Promise<any>;
    patientRedFlags: IPatientRedFlag[];
    staticReviewSystemsData: IStaticDataValue[];
    reviewOfSystemsData: IPatientSystemReview[];
    appointmentId: number;
    nextTab: () => void;
    doctorProfile: IDoctorProfile;
    pastConsultations: IAppointmentScheduleResponse[];
    currentMedication: IMedicinePrescription[];
    isSelf: boolean;
    uiConfiguration: any[];
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    patientChiefComplaints: ISymptom[],
    fetchPatientPastSessions: (patientId: number, subSectionKey: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    activeMedicines: any;
    responseData: any;
    modalResponse: any;
    handleCompleteConsultConfirmation: () => void
}

export interface PatientTherapistPlanTabState {
    error: string;
    errorDetails: string;
    tabWidgets: any;
    isSaving?: boolean,
    currentMedication: any;
}


class PatientTherapistPlanTab extends React.Component<PatientTherapistPlanTabProps, PatientTherapistPlanTabState> {

    constructor(props: PatientTherapistPlanTabProps) {
        super(props);
        this.state = {
            error: null,
            errorDetails: null,
            tabWidgets: [...sessionNotesConfiguration],
            isSaving: false,
            currentMedication: this.props.currentMedicalProfile.currentConsultationData.prescriptionMedicines && this.props.currentMedicalProfile.currentConsultationData.prescriptionMedicines.prescriptionMedicationList == undefined ?
                [] : this.props.currentMedicalProfile.currentConsultationData.prescriptionMedicines && this.props.currentMedicalProfile.currentConsultationData.prescriptionMedicines.prescriptionMedicationList
        }
    }

    componentWillUnmount() {
        if (this.props.doctorType === "MIND_THERAPIST")
            this.saveEditedLifestylePlan()
    }


    getFormattedObject = (widgetData: any, patientLifestylePlanObject: any) => {
        let planData: any = patientLifestylePlanObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey];
        let planObj = Object.values(planData);
        planObj && planObj.forEach((res: any) => {
            if (Array.isArray(res)) removeQ(res);
        })
        let keyName = Object.keys(planData);
        keyName && keyName.forEach((data) => {
            if (data === "prescriptionMedicationList") {
                planData[data] && planData[data].forEach((element: any, key: number) => {
                    let SlotList = [
                        {
                            slot: DosageSlots.BREAKFAST,
                            quantity: element.breakfastQuantity
                        },
                        {
                            slot: DosageSlots.LUNCH,
                            quantity: element.lunchQuantity
                        },
                        {
                            slot: DosageSlots.DINNER,
                            quantity: element.dinnerQuantity
                        }
                    ]
                    planData[data][key].slotList = SlotList;
                })
            }
        })
        if (planData.followupInfoSet && Array.isArray(planData.followupInfoSet)) {
            planData.followupInfoSet.map((data: any) => {
                data ? data.checkinType = CheckinType.FOLLOWUP : "";

            })
        }
        if (planData.referralInfoSet && Array.isArray(planData.referralInfoSet)) {
            planData.referralInfoSet.map((data: any) => {
                data ? data.checkinType = CheckinType.REFERRAL : "";
            })
        }
    }

    saveEditedClinicalPlan() {
        let updatedPersonalInfo = this.getPlanSaveObject();
        this.props.saveEditedPatientProfile(updatedPersonalInfo);
    }

    generatePatientReferrals = () => {
        let referrals: IDoctorCheckInInfo[] = [];
        _.map(this.props.patientPlan.consultationsByTherapist, (consultation: ConsultationPrescriptionItemRequest) => {
            if (!_.isEmpty(consultation.activities) && consultation.activities[0].checkinType === CheckinType.REFERRAL)
                referrals.push(ModelFactory.getAlbusReferralFromConsultationPlan(consultation))
        })
        return referrals;
    }

    generatePatientFollowUps = () => {
        let followUps: IDoctorCheckInInfo = ModelFactory.createNewDoctorCheckinInfo();
        _.map(this.props.patientPlan.consultationsByTherapist, (consultation: ConsultationPrescriptionItemRequest) => {
            if (!_.isEmpty(consultation.activities) && consultation.activities[0].checkinType === CheckinType.FOLLOWUP)
                followUps = ModelFactory.getAlbusReferralFromConsultationPlan(consultation);
        })
        return followUps;
    }

    generateScrollItems = () => {
        return [
            { name: "Health Targets", component: "health-target-section" },
            { name: "Build Plan", component: "build-plan-section" },
        ]
    }

    invalidItemError = (section: string, errorText?: string, errorDetail?: string) => {
        let errorDetails = errorDetail || `Error in ${section}. Please Review the form and proceed. ${errorText || ""}`;
        this.setState({
            error: errorText || AppMessages.PLAN_VALIDATION_ERROR,
            errorDetails
        })
    }

    validatePlan() {
        let status = true;
        let patientLifestylePlanStatus: any = {};
        this.state.tabWidgets.map((widgetData: any) => {
            patientLifestylePlanStatus[widgetData.subSectionKey] = (this as any | PatientTherapistPlanTab)[widgetData.subSectionKey].isFormDirty();
        })
        let isDirty = Object.values(patientLifestylePlanStatus).findIndex(obj => obj === true) > -1;
        if (!patientLifestylePlanStatus || isDirty) {
            this.state.tabWidgets.map((widgetData:any) => {
                if (patientLifestylePlanStatus[widgetData.subSectionKey]) {
                    this.invalidItemError(widgetData.subSectionTitle);
                }
            })
            status = false;
        }
        return status;
    }

    getPatientLifestylePlanObject() {
        let patientLifestylePlanObject: any = {};
        patientLifestylePlanObject[ConfigConstants.NEWCONFIGDATA] = {};

        this.state.tabWidgets.map((widgetData: any) => {
            patientLifestylePlanObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientTherapistPlanTab)[widgetData.subSectionKey].getSaveObject();
            this.getFormattedObject(widgetData, patientLifestylePlanObject);
        })
        return patientLifestylePlanObject;
    }


    saveEditedLifestylePlan = (newMedicine?: any) => {
        let patientMedicalProfile: IEHRSavePatientMedicalProfile = { ...this.props.currentMedicalProfile };
        this.props.saveEditedPatientProfile(patientMedicalProfile);
        if (newMedicine && patientMedicalProfile.currentConsultationData.prescriptionMedicines) {
            if (!patientMedicalProfile.currentConsultationData.prescriptionMedicines.prescriptionMedicationList) {
                patientMedicalProfile.currentConsultationData.prescriptionMedicines.prescriptionMedicationList = [];
            }
            patientMedicalProfile.currentConsultationData.prescriptionMedicines.prescriptionMedicationList.push(newMedicine);
            this.setState({ currentMedication: patientMedicalProfile.currentConsultationData.prescriptionMedicines.prescriptionMedicationList });
        }
        this.state.tabWidgets.map((widgetData: { subSectionKey: "prescriptionAdvice" | "prescriptionDiagnosis" | "prescriptionInstructions" | "prescriptionLabTest" | "prescriptionMedicines" | "prescriptionFollowup" }) => {
            if (patientMedicalProfile.currentConsultationData)
                patientMedicalProfile.currentConsultationData[widgetData.subSectionKey] = (this as any | PatientTherapistPlanTab)[widgetData.subSectionKey].getSaveObject();
        })
        this.props.saveEditedMedicalProfile(patientMedicalProfile);
    }

    savePatientLifestylePlan = () => {
        let patientMedicalProfile = this.getPatientLifestylePlanObject();
        this.saveEditedLifestylePlan();

        if (this.validatePlan()) {
            this.setState({ isSaving: true, error: null });
            this.props.savePatientMedicalProfile(this.props.patientId, patientMedicalProfile, this.props.appointmentId, this.props.doctorType).then(() => {
                this.props.reviewPlan(true, true, MODAL_SCREENS[5]);
                //this.props.nextTab();
            }).catch(err => {
                let errorMessage = "", schemaErrors: string[] = []
                if (Array.isArray(err)) {
                    err.map((element: any) => {
                        errorMessage += `${element.subSectionName}, `;
                        schemaErrors = [...schemaErrors, ...(element.errors || [])]
                    });
                    errorMessage = errorMessage.slice(0, -2);
                }
                this.setState({
                    error: AppMessages.PATIENT_LIFESTYLE_PLAN_SAVE_ERROR,
                    errorDetails: `Error in ${errorMessage} Please Review the form and proceed.\n${schemaErrors.join("\n")}`,
                    isSaving: false
                })
            });
        }
    }

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null
        })
    }

    addMedicineToMedicationList = (medicine: any) => {
        this.saveEditedLifestylePlan(medicine);
    }

    formatPastData = (tabs: any) => {
        let pastDataTable: any[] = [];
        tabs.forEach((tab: any, index: number) => {
            pastDataTable.push([tab.displayValue]);
            const tabKey = tab.key;
            let key = _.get(this.props, `${tabKey}`)
            let subKey = key && key[tab.subKey];
            let value = subKey && Array.isArray(subKey) && subKey.map((data: any) => data[tab.targetKey].displayValue ? data[tab.targetKey].displayValue : data).join(", ");
            pastDataTable[index].push(value);
        })
        return pastDataTable;
    }

    formatActiveMedications = (activeMedications: any) => {
        return activeMedications.map((medicine: any) => {
            let quantity = medicine && medicine.slotList && medicine.slotList.map((medicineData: any) => {
                return medicineData.quantity;
            })
            return {
                1: {
                    displayValue: medicine.brand && medicine.brand.displayValue ? medicine.brand.displayValue : medicine.brand,
                    internalValue: medicine.brand && medicine.brand.internalValue ? medicine.brand.internalValue: medicine.brand,
                    helperText: medicine.genericName && medicine.genericName.displayValue ? medicine.genericName.displayValue : medicine.genericName
                },
                2: {
                    displayValue: medicine && medicine.medicineType
                },
                3: {
                    displayValue: medicine && medicine.dosage
                },
                4: {
                    displayValue: medicine && medicine.medicineFrequency && medicine.medicineFrequency.count + "/" + medicine.medicineFrequency.unit
                },
                5: {
                    displayValue: quantity && quantity.join("-")
                },
                originalObject: medicine
            }
        })
    }

    handleProceedToNextTab = () => {
        this.props.nextTab()
    }

    handleCompleteNow = () => {
        this.saveEditedLifestylePlan()
        this.props.handleCompleteConsultConfirmation()
    }

    render() {
        let errorMessage = !_.isNull(this.state.error) ? this.state.error : AppMessages.PRESCRIPTION_VALIDATION_ERROR;
        let errorDetails = this.state.errorDetails;
        let symptoms: any[] = [];
        this.props.currentMedicalProfile.currentConsultationData && this.props.currentMedicalProfile.currentConsultationData.chiefComplaints && this.props.currentMedicalProfile.currentConsultationData.chiefComplaints.patientComplaints && this.props.currentMedicalProfile.currentConsultationData.chiefComplaints.patientComplaints.forEach((data: any) => {
            symptoms.push(data.complaint.displayValue)
        })
        if (this.props.modalResponse
            && !this.props.modalResponse.status
            && this.props.modalResponse.modalUIConfig
            && this.props.modalResponse.modalUIConfig.modalData
            && symptoms.includes(this.props.modalResponse.modalUIConfig.modalData)) {
            let prevSelections = symptoms;
            let index = prevSelections.indexOf(this.props.modalResponse.modalUIConfig.modalData);
            prevSelections.splice(index, 1);
            symptoms = prevSelections;
        }

        return (
            <div className="patient-therapist-plan-container">
                {/*<ScrollToContainer componentToScroll={document.getElementsByClassName("ongoing-consultation-main-cont")[0]} scrollItems={this.generateScrollItems()}/>*/}
                {
                    !_.isNull(this.state.error) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0}
                        closeError={this.clearErrorMessage} />
                }

                {this.state.tabWidgets.map((widgetData: any, index: number) => {
                    let tabData = AppUtils.consultationDataDecider(this.props.currentMedicalProfile, true, widgetData.subSectionKey);
                    // let tabData = this.props.currentMedicalProfile && this.props.currentMedicalProfile[ConfigConstants.NEWCONFIGDATA] &&
                    //     this.props.currentMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] ? this.props.currentMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] : {};

                    const modalHeaders: any = [{ label: "session", display: "Session ", valueKey: "sessionNo" },
                    { label: "date", display: "Date: ", valueKey: "date" }];

                    if (widgetData.subSectionKey === "prescriptionDiagnosis") {
                        let DiagnosticConfig = widgetData.data[0] && widgetData.data[0].answerList[0] &&
                            widgetData.data[0].answerList[0] &&
                            widgetData.data.find((data: any) => data.key === "diagnosticData").answerList.find((data: any) => data.key === "pastData").tableRows;
                        tabData = {
                            ...tabData,
                            diagnosticData: this.formatPastData(DiagnosticConfig)
                        }
                    }

                    tabData = {
                        ...tabData,
                        complaints: symptoms
                    }

                    if (widgetData.subSectionKey === "prescriptionMedicines") {
                        let activeMedicines = this.props.activeMedicines ? this.props.activeMedicines : [];
                        tabData = {
                            ...tabData,
                            activeMedicines: this.formatActiveMedications(activeMedicines),
                            prescriptionMedicationList: this.state.currentMedication
                        }
                    }

                    return <div key={widgetData.subSectionKey} data-section={widgetData.subSectionKey} className="patient-info-subsection concern-section">
                        <GenericEditViewCont appointmentId={this.props.appointmentId} patientId={this.props.patientId} doctorName={this.props.doctorProfile.name}
                            ref={(patientTherapistPlanDOM) => { (this as any | PatientTherapistPlanTab)[widgetData.subSectionKey] = patientTherapistPlanDOM }}
                            displayMode={EditViewDisplayMode.EDIT}
                            widgetData={widgetData}
                            tabData={tabData}
                            fetchPatientPastSessions={this.props.fetchPatientPastSessions}
                            modalHeaders={modalHeaders}
                            notifyParent={this.addMedicineToMedicationList}
                            isNew={widgetData.isNewTypeList}
                            modalResponse={this.props.modalResponse} />
                    </div>
                })}

                <div className={"save-button collapsible-card"}>
                    <CTA innerText={"Complete Now"} theme={CTATheme.PRIMARY} onClick={this.handleCompleteNow} customStyle={{ display: "inline" }} />
                    <CTA innerText={"Proceed to Intake & History"} theme={CTATheme.PRIMARY} onClick={this.handleProceedToNextTab} customStyle={{ display: "inline" }} />
                </div>
            </div>
        );
    }
}

export default PatientTherapistPlanTab